import {
    ADD_BOOKING, BOOKING_ERROR, CANCEL_BOOKING, DELETE_BOOKING, GET_BOOKINGS, GET_MY_BOOKING
} from '../actions/types';

const initialState = {
    booking: null,
    bookings: [],
    loading: true,
    error: {}
}


export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case BOOKING_ERROR:
            return{
                ...state,
                error: payload,
                loading: false,
            };
        case GET_BOOKINGS:
            return {
                ...state,
                bookings: payload,
                loading: false,
            };
        case GET_MY_BOOKING:
            return {
                ...state,
                bookings: payload,
                loading: false,
            };
        case ADD_BOOKING:
            return {
                ...state,
                bookings: [payload, ...state.bookings],
                loading: false
            };
        case DELETE_BOOKING:
            return {
                ...state,
                bookings: state.bookings.filter(booking => booking._id !== payload),
                loading: false
            };
        case CANCEL_BOOKING:
            return {
                ...state,
                bookings: state.bookings.map(booking => booking._id === payload._id ? { ...booking, status: payload.status } : booking),
                loading: false
            };
        default:
            return state;
    }
}

